// components/Hero.jsx
import React from 'react';
import '../styles/Hero.css';
import plumbingImage from '../assets/p1.png'; // Add your image path

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      {/* Animated Background */}
      <div className="hero-bg">
        <div className="hero-bg-circle hero-bg-circle-1"></div>
        <div className="hero-bg-circle hero-bg-circle-2"></div>
        <div className="hero-bg-circle hero-bg-circle-3"></div>
        <div className="hero-bg-circle hero-bg-circle-4"></div>
        <div className="hero-bg-circle hero-bg-circle-5"></div>
        <div className="hero-bg-shine"></div>
        <div className="hero-grid-pattern"></div>
      </div>

      <div className="hero-container">
        {/* Left Content - Aligned Top */}
        <div className="hero-content">
          {/* Badge */}
          <div className="hero-badge">
            <span className="hero-badge-icon">✅</span>
            <span>Licensed & Insured Plumbers</span>
            <span className="hero-badge-pulse"></span>
          </div>

          {/* Main Heading */}
          <h1 className="hero-title">
            <span className="hero-title-line">Fast & Reliable</span>
            <span className="hero-title-highlight">Plumbing Services</span>
            <span className="hero-title-line">Available 24/7</span>
          </h1>

          {/* Description */}
          <p className="hero-description">
            Professional plumbers ready to fix any issue — from leaky faucets to 
            emergency pipe repairs. Same-day service available.
          </p>

          {/* CTA Buttons */}
          <div className="hero-buttons">
            <button className="hero-btn-primary" onClick={() => window.location.href = 'tel:+18334936242'}>
              <span className="hero-btn-shine"></span>
              <span className="hero-btn-content">
                📋 Book Service Now
              </span>
              <span className="hero-btn-glow"></span>
            </button>
            <button className="hero-btn-secondary" onClick={() => window.location.href = 'tel:+18334936242'}>
              <span className="hero-btn-icon">📞</span>
              Call Now: +1 (833) 493-6242
            </button>
          </div>

          {/* Trust Badges */}
          <div className="hero-trust">
            <div className="hero-trust-item">
              <span className="hero-trust-icon">⭐</span>
              <span>4.9/5 Rating</span>
            </div>
            <div className="hero-trust-divider"></div>
            <div className="hero-trust-item">
              <span className="hero-trust-icon">🏅</span>
              <span>Licensed Pros</span>
            </div>
            <div className="hero-trust-divider"></div>
            <div className="hero-trust-item">
              <span className="hero-trust-icon">⚡</span>
              <span>Same-Day Service</span>
            </div>
            <div className="hero-trust-divider"></div>
            <div className="hero-trust-item">
              <span className="hero-trust-icon">💰</span>
              <span>Upfront Pricing</span>
            </div>
          </div>

          {/* Stats */}
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-number">500+</span>
              <span className="hero-stat-label">Happy Customers</span>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat">
              <span className="hero-stat-number">4.9★</span>
              <span className="hero-stat-label">Average Rating</span>
            </div>
            <div className="hero-stat-divider"></div>
            <div className="hero-stat">
              <span className="hero-stat-number">24/7</span>
              <span className="hero-stat-label">Emergency Service</span>
            </div>
          </div>
        </div>

        {/* Right Side - Image (centered vertically) */}
        <div className="hero-image">
          <div className="hero-image-wrapper">
            <div className="hero-image-glow"></div>
            <img 
              src={plumbingImage} 
              alt="Professional Plumber" 
              className="hero-image-img"
            />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hero-scroll-indicator">
        <span>Scroll</span>
        <div className="hero-scroll-line">
          <div className="hero-scroll-dot"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;